import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {getToken} from "../shared/TokenInformation/TokenInformation"
const ProtectedRoute = (props) => {
    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const checkUserToken = () => {
        const tokenInfo = getToken();
        if (!tokenInfo || tokenInfo === 'undefined') {
            setIsLoggedIn(false);
            return navigate('/');
        }
        setIsLoggedIn(true);
    }
    useEffect(() => {
            checkUserToken();
            //eslint-disable-next-line react-hooks/exhaustive-deps
        }, [isLoggedIn]);
        
    return (
        <React.Fragment>
            {
                isLoggedIn ? props.children : null
            }
        </React.Fragment>
    );
}
export default ProtectedRoute;